var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9606 3.18644C11.9606 3.22881 12 3.22881 11.9606 3.18644C12 3.22881 12 3.22881 12 3.27119V3.52542L5.93701 11.8729L5.89764 11.9153L5.85827 11.9576C5.8189 11.9576 5.8189 12 5.77953 12H5.62205C5.58268 12 5.58268 12 5.58268 11.9576L5.54331 11.9153L5.50394 11.8729L4.95276 11.2797C4.59843 10.8983 4.20472 10.5169 3.77165 10.0508C3.33858 9.62712 2.7874 9.0339 2.07874 8.31356L2 8.27119V8.22881V8.18644V8.14407V8.1017V8.05932V8.01695V7.97458V7.9322L2.31496 7.59322L2.66929 7.21186C2.7874 7.08475 2.86614 7 2.94488 6.87288C3.02362 6.78814 3.06299 6.74576 3.06299 6.70339L3.10236 6.66102L3.14173 6.61864L3.25984 6.57627H3.41732C3.41732 6.57627 3.45669 6.57627 3.45669 6.61864C3.49606 6.61864 3.49606 6.66102 3.49606 6.66102L3.53543 6.70339L3.85039 7.04237C4.04724 7.25424 4.28346 7.4661 4.51968 7.72034C4.75591 7.97458 5.07087 8.31356 5.46457 8.69492L10.3858 2.04237L10.4252 2H10.6614C10.6614 2 10.7008 2 10.7008 2.04237L11.9606 3.18644Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWhite);
export default __webpack_public_path__ + "static/media/Check-white.38b0b753a081875f46f9fdbde5efd733.svg";
export { ForwardRef as ReactComponent };